import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class UserService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }


  register(user){
    let url = 'register'
    return this.http.post(this.BASE_URL_API_PUBLIC + url,user,this.storage.getHeaders())
  }

  registerGuest(user){
    let url = 'donate_as_guest'
    return this.http.post(this.BASE_URL_API_PUBLIC + url,user,this.storage.getHeaders())
  }


  login(user){
    let url = 'login'
    return this.http.post(this.BASE_URL_API_PUBLIC + url,user,this.storage.getHeaders())
  }

  getSalutations(){
    let url = 'get_salutations'
    return this.http.get(this.BASE_URL_API_PUBLIC + url,this.storage.getHeaders())
  }

  viewProfile(){
    let url = 'view_profile'
    return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
  }

  updateProfile(user){
    let url = 'update_profile'
    return this.http.post(this.BASE_URL_API_WEBSITE + url,user,this.storage.getHeaders())
  }

  changePassword(user){
    let url = 'change_password'
    return this.http.post(this.BASE_URL_API_WEBSITE + url,user,this.storage.getHeaders())
  }

  forgotPassword(body){
    let url = 'forgot_password'
    return this.http.post(this.BASE_URL_API_PUBLIC + url,body,this.storage.getHeaders())
  }

  forgotPasswordUpdate(user){
    let url = 'forgot_password_update'
    return this.http.post(this.BASE_URL_API_PUBLIC + url,user,this.storage.getHeaders())
  }

  uploadAvatar(photo){
      let url = 'upload_avatar';
      const f = new FormData;
      f.append('avatar_url',photo)
      return this.http.post(this.BASE_URL_API_WEBSITE + url, f,this.storage.getHeaders())
  }

  removeAvatar(){
    let url = 'delete_avatar'
    return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
  }

}
